import { Table, Tag, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import trans from "../../../../utils";
import { formatDateString } from "../../../../JsHelpers/DateFormat";

export function MembersTab({ data }) {
  const columns = [
    {
      title: trans("Name"),
      dataIndex: "user",
      key: "user",
      render: (user, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Avatar size="small" icon={<UserOutlined />} />
          <span>{user?.name || "-"}</span>
        </div>
      ),
    },
    {
      title: trans("Email"),
      dataIndex: "user",
      key: "user",
      render: (user) => user?.email || "-",
    },
    {
      title: trans("Phone"),
      dataIndex: "user",
      key: "user",
      render: (user) => user?.phone || "-",
    },
    {
      title: trans("Join Date"),
      dataIndex: "joinedAt",
      key: "joinedAt",
      render: (date) => formatDateString(date),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data?.members || []}
      rowKey={(record) => record.id || record.email}
      pagination={false}
      size="small"
      scroll={{ y: 400 }}
    />
  );
}
